module.exports = __webpack_public_path__ + "img/66.fc7b2d0f.png";